/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconChevron.vue?vue&type=template&id=495780dc"
import script from "./IconChevron.vue?vue&type=script&lang=js"
export * from "./IconChevron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495780dc')) {
      api.createRecord('495780dc', component.options)
    } else {
      api.reload('495780dc', component.options)
    }
    module.hot.accept("./IconChevron.vue?vue&type=template&id=495780dc", function () {
      api.rerender('495780dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconChevron.vue"
export default component.exports